<template>
  <div>
    <el-dialog
      v-if="!isMobile"
      append-to-body
      title="评论"
      :visible="show"
      :close-on-click-modal="false"
      width="600px"
      @close="closeDialog"
    >
      <fix-side-comment-list />
      <fix-side-comment-commit />
    </el-dialog>
    <van-popup
      v-if="isMobile"
      :value="show"
      class="m-popup"
      closeable
      close-icon-position="top-right"
      position="bottom"
      round
      :style="{ height: '50%' }"
      :safe-area-inset-bottom="true"
      @click-overlay="closeDialog"
      @click-close-icon="closeDialog"
    >
      <div class="m-header">
        <div class="title">评论</div>
      </div>
      <div class="m-comment-list">
        <fix-side-comment-list />
      </div>
       <fix-side-comment-commit />
    </van-popup>
    
  </div>
</template>

<script>
import fixSideCommentList from "./fix-side-comment-list.vue";
import fixSideCommentCommit from "./fix-side-comment-commit.vue";
import Vue from "vue";
import { Popup } from "vant";
Vue.use(Popup);

export default {
  components: { fixSideCommentList, fixSideCommentCommit },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      vForm: {
        worksId: this.$route.query.id,
        id: "",
        lid: "",
        avatar: "",
        nickname: "",
        content: "",
      },
    };
  },

  created() {
    this.initUser();
  },

  methods: {
    initUser() {
      let user = localStorage.getItem("v-comment-user");
      if (!user) {
        let lid = this.utils.UUID.generate();
        user = {
          lid,
          nickname: "游客" + lid.slice(0, 8),
          avatar:
            "https://vybbasevr.vyb.cn/dabf8a36_39ff_45d8_b515_c6bccfab715b1646814219184",
        };
        localStorage.setItem("v-comment-user", JSON.stringify(user));
      }
      return user;
    },

    closeDialog() {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style scoped>
.m-header {
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}
.m-comment-list{
  padding: 20px 0;
  flex:1;
  box-sizing: border-box;
  min-height: 0;
}
.m-comment-list ::v-deep .item{
  margin: 0 20px 10px 20px;
}
.m-comment-list ::v-deep .comment-list{
  height:100%;
}
.m-popup{
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
